import { useContext } from 'react';
import ElementsShowInViewContext from '../ElementsShowInViewContext';

export default function useElementsShowInView() {
  return useContext(ElementsShowInViewContext);
}
